import {bounceTrackInstrument} from 'engine/BouncingEngine.js';
import Notes from 'midi/Notes.js';
import {sleep} from "utils/sleep.js";
import SoundUploader from 'api/SoundUploader.js';
import Sample from 'repos/Sample.js';
import {
    setLoadingText} from 'actions/index.js';
import {getPatternLength} from 'engine/BouncingEngine.js';
import {crop} from 'engine/Crop.js';
import Tone from 'tone';

export const freezeInstrument = async (sequencerEngine) => {
    let track = sequencerEngine.getSelectedTrack();

    let name = track.presetName || track.getName();
    sequencerEngine.store.dispatch(setLoadingText("Freezing instrument"));
    await sleep(250);
    let bounces = await bounceTrackInstrument(sequencerEngine, track);
    let chopped = await chopByNote(sequencerEngine, bounces, name);
    // now create a new instrument and add samples to it

    let sampledInstrument = sequencerEngine.addSampledInstrumentTrack();
    sampledInstrument.resampledFrom = track.preset;
    let i=0;
    let promises = [];
    for (let sample of chopped) {
        sequencerEngine.recordingsToSave.push(sample);
        promises.push(sampledInstrument.instrument.newSample(-12 + i*3, sample));
        i++;
    }
    await Promise.all(promises);
    let release = track.instrument ? track.instrument.ampEnvelope.release : 2000;
    sampledInstrument.instrument.releaseParameter.set(release);
    sequencerEngine.store.dispatch(setLoadingText(undefined));

    // auto save
    if (track.preset) {
        /*
        // save the preset
        await sequencerEngine.saveTrackPreset(
            sampledInstrument.trackNumber,
            name,
            false,
            0
        );

        // save the sounds
        await sequencerEngine.saveAnyNewRecordings(0);
        sequencerEngine.recordingsToSave = [];
        */
    }
};

const chopByNote = async (sequencerEngine, audioBuffer, name) => {
    let bounces = [];
    let time = 0;

    let soundUploader = new SoundUploader(
        2, (soundId, ipfsHash, loopNumber) => []);

    let loops = sequencerEngine.state.freeze.loops;
    let len = 64;
    let promises = [];
    let numPatterns = 24;
    for (let patternNumber=0; patternNumber < numPatterns; patternNumber++) {
        let start = time;
        let end = start + Tone.Master.context.sampleRate * len * new Tone.Time('32n').toMilliseconds() / 1000.0;
        let cropped = crop(audioBuffer, start, end, Tone.Master.context);
        time = end;
        promises.push(new Promise(async (resolve) => {
            let ipfsHash = await soundUploader.uploadBufferToIpfs(cropped);
            let sample = new Sample(ipfsHash);
            sample.audioBuffer = cropped;
            sample.tempo = sequencerEngine.tempo;
            sample.name = name + ': ' + Notes.fromTranspose(-12 + patternNumber).toString();
            sample.tags = ['Resampled', name];
            resolve(sample);
        }));
    }


    return await Promise.all(promises);
};

